'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Choose = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {ComponentType} from 'react' */

/*::
type Props<T> = {|
  selected?: T,
  options: Array<T>,
  children: (T, void => void, Array<T>) => React.Node,
|}
type State<T> = {|
  chosen?: T,
|}
*/
var Choose = exports.Choose = function (_React$Component) {
  _inherits(Choose, _React$Component);

  function Choose(props /*: Props<*> */) {
    _classCallCheck(this, Choose);

    var _this = _possibleConstructorReturn(this, (Choose.__proto__ || Object.getPrototypeOf(Choose)).call(this, props));

    _this.choose = function (chosen /*:**/) {
      return _this.setState({ chosen: chosen });
    };

    _this.state = {
      chosen: _this.props.selected || _this.props.options[0]
    };
    return _this;
  }

  _createClass(Choose, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.state.chosen, this.choose, this.props.options);
    }
  }]);

  return Choose;
}(React.Component /*:: <Props<*>, State<*>> */);

Choose.propTypes = {
  /** one of the options or the first one by default */
  selected: _propTypes2.default.any,
  /** a list of possible things to be selected */
  options: _propTypes2.default.array.isRequired,
  /** (a, (a -> void), [a]) -> React.Component */
  children: _propTypes2.default.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Choose.js
// module id = 604
// module chunks = 0